/**
 * Цвета группировки участников игровых режимов.
 *
 * Правило: одна банда (`teams[].is_team === true`) — один цвет, оттенками
 * разводятся участники внутри неё. Одиночный игрок получает цвет по своему
 * стабильному id.
 *
 * Модуль общий для всех режимов с командной игрой (классика, кейсбатл), чтобы
 * одна и та же банда была одного цвета во всех местах: полоса группы в ленте
 * ставок, плитки treemap, сводка банд, кромка слота баттла.
 */

export const PARTICIPANT_PALETTE = [
  '#FF6B6B',
  '#4D96FF',
  '#FFB347',
  '#9B5DE5',
  '#00BBF9',
  '#F15BB5',
  '#FF9F1C',
  '#6C8CFF',
  '#845EC2',
  '#FF6F91',
  '#FFD166',
  '#7FDBFF',
  '#FF7F50',
  '#B39DDB',
  '#00B8A9',
  '#FF8FAB',
  '#F4A261',
  '#5E60CE',
  '#F72585',
  '#4CC9F0'
]

export const hashString = (value) => {
  const text = String(value || '')
  let hash = 0
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export const pickPaletteColor = (key) => PARTICIPANT_PALETTE[hashString(key) % PARTICIPANT_PALETTE.length]

/**
 * Осветление hex-цвета в сторону белого: оттенки тиммейтов внутри цвета банды.
 * ratio 0 — исходный цвет, 1 — белый.
 */
export const lightenHex = (hex, ratio = 0) => {
  const normalized = String(hex || '').replace('#', '')
  if (normalized.length !== 6) return hex
  const clamped = Math.min(0.6, Math.max(0, ratio))
  const channels = [0, 2, 4].map((offset) => {
    const value = parseInt(normalized.slice(offset, offset + 2), 16)
    const mixed = Math.round(value + (255 - value) * clamped)
    return mixed.toString(16).padStart(2, '0')
  })
  return `#${channels.join('')}`
}

/**
 * Карта `slug банды → цвет`. Только банды с 2+ участниками: банда с
 * `is_team: false` играет как одиночка, отдельного цвета не заслуживает.
 */
export const buildTeamColorMap = (teams = []) => {
  const map = new Map()
  ;(teams || [])
    .filter((team) => team?.is_team && team?.slug)
    .forEach((team) => map.set(team.slug, pickPaletteColor(team.slug)))
  return map
}
